import { render, staticRenderFns } from "./UserBox.vue?vue&type=template&id=03d17562&scoped=true"
import script from "./UserBox.vue?vue&type=script&lang=js"
export * from "./UserBox.vue?vue&type=script&lang=js"
import style0 from "./UserBox.vue?vue&type=style&index=0&id=03d17562&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d17562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d17562')) {
      api.createRecord('03d17562', component.options)
    } else {
      api.reload('03d17562', component.options)
    }
    module.hot.accept("./UserBox.vue?vue&type=template&id=03d17562&scoped=true", function () {
      api.rerender('03d17562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/UserBox.vue"
export default component.exports